module.exports = __webpack_public_path__ + "static/media/no_image_icon.34ef6e46.png";